import { render, staticRenderFns } from "./create-wizard.vue?vue&type=template&id=25a018d3&scoped=true&"
import script from "./create-wizard.vue?vue&type=script&lang=ts&"
export * from "./create-wizard.vue?vue&type=script&lang=ts&"
import style0 from "./create-wizard.vue?vue&type=style&index=0&id=25a018d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a018d3",
  null
  
)

export default component.exports